// Re-export all types
export * from './types/index.js';
// Utility functions
export const formatCurrency = (amount) => {
    return `฿${amount.toLocaleString('th-TH', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
};
export const formatDate = (date) => {
    return new Date(date).toLocaleDateString('th-TH', {
        day: 'numeric',
        month: 'short',
        hour: '2-digit',
        minute: '2-digit',
    });
};
export const formatThaiMonth = (date) => {
    return date.toLocaleDateString('th-TH', { month: 'long', year: 'numeric' });
};
export const getYearMonth = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    return `${year}-${month}`;
};
// PromptPay QR Generation
export const generatePromptPayQR = async (phoneNumber, amount) => {
    const { default: generatePayload } = await import('promptpay-qr');
    const { toDataURL } = await import('qrcode');
    // Clean phone number (remove dashes and spaces)
    const cleanNumber = phoneNumber.replace(/[-\s]/g, '');
    // Generate PromptPay payload
    const payload = generatePayload(cleanNumber, { amount });
    // Generate QR code as data URL
    const qrDataUrl = await toDataURL(payload, {
        errorCorrectionLevel: 'M',
        margin: 2,
        width: 300,
    });
    return qrDataUrl;
};
//# sourceMappingURL=index.js.map